import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  SET_ERROR,
  FETCH_FILTERS_SUCCESS,
  UPDATE_FILTERS_SUCCESS,
  UPDATE_FILTERS,
  SET_PRESET,
  ADD_PRESET_SUCCESS,
  EDIT_PRESET_SUCCESS,
  SET_CURRENT_PRESET,
  UPDATE_CURRENT_PRESET_FILTERS,
  UPDATE_CURRENT_PRESET_FILTERS_SUCCESS,
  RESET_CURRENT_PRESET_FILTERS,
  REMOVE_PRESET_SUCCESS,
  UPDATE_SELECT_STORE,
  SET_DYNAMIC_FILTERS_STATUS,
  SET_SELECT_STORE,
  RESET_FILTERS_SUCCESS,
  RESET
} from "./locationsSelectorSagas";

export const initialState = {
  currentUser: {},
  isLoading: true,
  filters: {},
  presets: {},
  status: "idle",
  errors: null,
  selectedPreset: null,
  currentPreset: {},
  selectedFilters: {},
  triggerText: "",
  selectStoreFilters: [],
  pendingFilters: []
};

const getTriggerText = (locations, selectedPreset) => {
  if (selectedPreset) return selectedPreset;

  if (locations.length === 1) return locations[0].name;

  return "All Stores" + " (" + locations.length + ")";
};

const getChecked = (options) => options.filter((filter) => filter.checked);

export const getSelectedFilters = (filters) => {
  let selectedFilters = {};

  for (let key in filters) {
    selectedFilters = {
      ...selectedFilters,
      [key]: getChecked(filters[key])
    };
  }

  return selectedFilters;
};

const getSelectStoreFilters = (payload, allStores, selectedStores) => {
  if (!payload) return selectedStores;

  let filteredStoredIds = payload.split(",");

  if (filteredStoredIds.length === 1) return selectedStores;
  return allStores.filter((store) => filteredStoredIds.includes(store.id.toString()));
};

const adjustOptions = (allOptions, selectedOptions) => {
  return allOptions.map((option) => {
    let foundEl = selectedOptions.find((el) => el.id === option.id);
    if (foundEl) {
      return { ...foundEl, checked: true };
    }
    return { ...option, checked: false };
  });
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [ADD_PRESET_SUCCESS]: (state, { payload: { type, ...rest } }) => ({
      ...state,
      status: "success",
      presets: { ...state.presets, [type]: [...state.presets[type], rest] }
    }),
    [EDIT_PRESET_SUCCESS]: (state, { payload }) => {
      let presets = {
        ...state.presets,
        [state.currentPreset.type]: state.presets[state.currentPreset.type].map((preset) =>
          preset.id === payload.id ? payload : preset
        )
      };

      let filters =
        state.selectedPreset && state.selectedPreset[0].id === payload.id
          ? {
              filters: payload.filters,
              selectedFilters: getSelectedFilters(payload.filters),
              selectedPreset: [payload]
            }
          : {};

      return {
        ...state,
        status: "success",
        presets,
        triggerText: payload.id == state.currentUser.presetId ? payload.name : state.triggerText,
        ...filters
      };
    },
    [RESET_CURRENT_PRESET_FILTERS]: (state) => {
      let preset = state.presets[state.currentPreset.type].filter(
        (preset) => preset.id === state.currentPreset.id
      );

      return {
        ...state,
        currentPreset: { ...state.currentPreset, filters: preset[0].filters }
      };
    },
    [SET_PRESET]: (state, { payload }) => ({
      ...state,
      selectedPreset: [payload],
      filters: payload.filters,
      selectedFilters: getSelectedFilters(payload.filters)
    }),
    [SET_CURRENT_PRESET]: (state, action) => ({
      ...state,
      currentPreset: action.payload
    }),
    [UPDATE_CURRENT_PRESET_FILTERS]: (state, { payload: { data, key } }) => ({
      ...state,
      currentPreset: {
        ...state.currentPreset,
        filters: {
          ...state.currentPreset.filters,
          [key]: adjustOptions(state.currentPreset.filters[key], data)
        }
      }
    }),
    [UPDATE_CURRENT_PRESET_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      currentPreset: {
        ...state.currentPreset,
        filters: { ...state.currentPreset.filters, ...action.payload }
      }
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, { payload: { organization_id, short_url } }) => ({
      ...state,
      currentUser: { organization_id, short_url }
    }),
    [FETCH_FILTERS_SUCCESS]: (
      state,
      {
        payload: {
          filters,
          presets,
          selectedDefaultFilters,
          presetId,
          presetType,
          locations,
          filteredStores
        }
      }
    ) => {
      let selectedPreset = presetType
        ? presets[presetType].filter((preset) => preset.id == presetId)
        : null;

      let presetName = selectedPreset && selectedPreset.length ? selectedPreset[0].name : "";

      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          allDefaultFilters: { ...filters, locations },
          selectedDefaultFilters,
          presetId: presetName ? presetId : null
        },
        filters,
        selectedFilters: {
          ...selectedDefaultFilters,
          stores: presetName
            ? getChecked(selectedPreset[0].filters.stores)
            : getSelectStoreFilters(filteredStores, filters.stores, selectedDefaultFilters.stores)
        },
        presets: presets,
        selectedPreset: presetName ? [{ ...selectedPreset[0], type: presetType }] : null,
        triggerText: getTriggerText(selectedDefaultFilters.stores, presetName)
      };
    },
    [UPDATE_FILTERS]: (state, { payload: { data, key } }) => ({
      ...state,
      filters: {
        ...state.filters,
        [key]: adjustOptions(state.filters[key], data)
      },
      selectedFilters: {
        ...state.selectedFilters,
        [key]: data.map((option) => ({ ...option, checked: true }))
      },
      selectedPreset: null
    }),
    [SET_SELECT_STORE]: (state, { payload }) => ({
      ...state,
      selectStoreFilters: {
        stores: getSelectStoreFilters(payload, state.filters.stores, state.selectedFilters.stores),
        presetId: state.selectedPreset ? state.selectedPreset[0].id : null
      }
    }),
    [UPDATE_SELECT_STORE]: (state) => ({
      ...state,
      selectStoreFilters: {
        stores: state.selectedFilters.stores.map((filter) => ({ ...filter, checked: false })),
        presetId: state.selectedPreset ? state.selectedPreset[0].id : "-1",
        presetType: state.selectedPreset ? state.selectedPreset[0].type : ""
      }
    }),
    [UPDATE_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: { ...state.filters, ...action.payload },
      selectedFilters: { ...state.selectedFilters, ...action.payload }
    }),
    [SET_DYNAMIC_FILTERS_STATUS]: (state, { payload }) => ({
      ...state,
      pendingFilters: payload
    }),
    [REMOVE_PRESET_SUCCESS]: (state, { payload: { id } }) => {
      let presets = {
        ...state.presets,
        [state.currentPreset.type]: state.presets[state.currentPreset.type].filter(
          (preset) => preset.id !== id
        )
      };
      return {
        ...state,
        presets: presets,
        selectStoreFilters: {
          ...state.selectStoreFilters,
          presetId: state.currentPreset.id == id ? "-1" : state.selectStoreFilters.presetId
        }
      };
    },
    [RESET]: (state) => ({
      ...state,
      currentPreset: {},
      errors: null,
      status: "idle"
    }),
    [RESET_FILTERS_SUCCESS]: (state, action) => ({
      ...state,
      filters: action.payload,
      selectedFilters: action.payload,
      selectedPreset: null
    })
  },

  initialState
);
